<template>
  <div>
    <v-autocomplete
      id="temas-select"
      v-model="municipioid"
      :items="values"
      :label="
        isParceiro
          ? 'Parceiros'
          : isSala
          ? 'Salas'
          : isGov
          ? 'Projetos'
          : 'Municípios'
      "
      placeholder="Selecione..."
      v-on:change="
        (e) => {
          $emit('onChange', municipioid);
          $emit(
            'nameChange',
            allValues
              .filter((val) => municipioid.includes(val.municipioId))
              .map((item) => item.nome)
          );
        }
      "
      :disabled="disabled"
      :clearable="clearable"
      :multiple="multiple"
      item-value="municipioId"
      item-text="nome"
      :rules="rules"
    >
      <template v-slot:selection="{ item, index }">
        <v-chip v-bind="item" small v-if="index < maxDisplay">
          <span>{{ item.nome }}</span>
        </v-chip>
        <span v-if="index === maxDisplay" class="grey--text caption"
          >(+{{ municipioid.length - maxDisplay }} municipios)</span
        >
      </template>
      <template slot="no-data"> Nenhum Município retornado </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { cityAPI } from "@/modules/city";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AppEixoCombobox",
  computed: {
    ...mapGetters([
      "isFullAdmin",
      "uf",
      "logo",
      "isAnalista",
      "isSala",
      "isParceiro",
      "isGov",
    ]),
  },
  props: {
    rules: {
      type: Array,
      default: () => {
        [];
      },
    },
    clearable: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    value: { type: Array | Object },
    filterByStatusAndProject: { type: Object },
  },
  watch: {
    value: {
      handler(val, oldVal) {
        this.municipioid = val;
      },
      deep: true,
    },
    filterByStatusAndProject: {
      handler(val) {
        if (val.statusId.length || val.projetoId)
          this.values = this.allValues.filter((item) => {
            if (val.statusId.length && val.projetoId)
              return (
                val.statusId.includes(item.statusId) &&
                val.projetoId == item.projetoId
              );
            if (val.statusId.length)
              return val.statusId.includes(item.statusId);
            if (item.projetoId) return val.projetoId == item.projetoId;
          });
        else this.values = this.allValues;
      },
      deep: true,
    },
  },

  methods: {
    loadCities() {
      cityAPI.list().then((resp) => {
        this.values = resp.data;
        if (this.municipioid) {
          this.municipioid = this.values.filter(
            (item) => item.municipioId == this.$route.params.id
          )[0];
        }

        if (Array.isArray(this.value))
          this.municipioid = this.values.filter((item) =>
            this.value.includes(item.municipioId)
          );
        this.allValues = this.values;
      });
    },
  },
  mounted() {
    this.loadCities();
  },

  data() {
    return {
      values: [],
      allValues: [],
      municipioid: this.$route.params.id || this.value,
      maxDisplay: 1,
    };
  },
};
</script>
